module.exports = __webpack_public_path__ + "public/img/fx3.570c9d6c.png";